import React, { useState, useRef, useEffect } from 'react';
import { FAVICON_TALKU } from './logos';
import ProfileMenu from './ProfileMenu';
import NotificationPanel from './NotificationPanel';
import { useInboxAlerts, AlertToasts, openConversation } from './InboxAlerts';

const SF = `'SF Pro Display', 'SF Pro Text', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif`;

const IcoDashboard  = ({a}) => <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="3" width="7" height="7" rx="1.5"/><rect x="14" y="3" width="7" height="7" rx="1.5"/><rect x="3" y="14" width="7" height="7" rx="1.5"/><rect x="14" y="14" width="7" height="7" rx="1.5"/></svg>;
const IcoChat       = ({a}) => <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></svg>;
const IcoBox        = ({a}) => <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round"><path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 0 1-8 0"/></svg>;
const IcoUsers      = ({a}) => <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75"/></svg>;
const IcoFlow       = ({a}) => <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round"><polygon points="12 2 2 7 12 12 22 7 12 2"/><polyline points="2 17 12 22 22 17"/><polyline points="2 12 12 17 22 12"/></svg>;
const IcoMega       = ({a}) => <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round"><polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"/><path d="M19.07 4.93a10 10 0 0 1 0 14.14"/><path d="M15.54 8.46a5 5 0 0 1 0 7.07"/></svg>;
const IcoCampaign   = ({a}) => <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round"><path d="M22 2L11 13"/><path d="M22 2L15 22L11 13L2 9L22 2Z"/></svg>;
const IcoSettings   = ({a}) => <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round"><circle cx="12" cy="12" r="3"/><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"/></svg>;
const IcoVideo      = ({a}) => <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="5" width="14" height="14" rx="2.5"/><path d="M16 10l6-3v10l-6-3z"/></svg>;
const IcoBell       = () => <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round"><path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"/><path d="M13.73 21a2 2 0 0 1-3.46 0"/></svg>;
const IcoHelp       = () => <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round"><circle cx="12" cy="12" r="10"/><path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"/><line x1="12" y1="17" x2="12.01" y2="17"/></svg>;

const NAV_ITEMS = [
  { id:'Dashboard',      label:'Dashboard',      Icon:IcoDashboard },
  { id:'Conversaciones', label:'Conversaciones',  Icon:IcoChat },
  { id:'Pedidos',        label:'Pedidos',         Icon:IcoBox },
  { id:'Contactos',      label:'Contactos',       Icon:IcoUsers },
  // { id:'Flujos',         label:'Flujos',          Icon:IcoFlow },   // oculto 7-oct-2026 (pedido del dueño)
  { id:'Marketing',      label:'Marketing',       Icon:IcoMega },
  { id:'Campañas',       label:'Campañas',        Icon:IcoCampaign },
  // { id:'Video IA',       label:'Video IA',        Icon:IcoVideo },  // oculto 7-oct-2026 (Sora 2 dado de baja)
  { id:'Configuraciones',label:'Configuraciones', Icon:IcoSettings },
];

export default function Layout({ user, activeNav, onNav, onLogout, children }) {
  const [showNotifs, setShowNotifs] = useState(false);
  const [mobileMenu, setMobileMenu] = useState(false);

  const handleNav = (id) => { setMobileMenu(false); if (onNav) onNav(id); };
  const bellRef = useRef(null);
  const { unread, toasts, leaving, dismiss } = useInboxAlerts(activeNav, onNav);
  const openConv = (conv) => openConversation(conv, activeNav, onNav);
  const unreadN = unread.length;

  // Escala compacta (80 %) automática en pantallas de escritorio pequeñas (901–1440 px, ej. 1366×768).
  useEffect(() => {
    const apply = () => {
      const w = window.innerWidth;
      document.documentElement.classList.toggle('tk-esc80', w > 900 && w <= 1440);
    };
    apply();
    window.addEventListener('resize', apply);
    return () => { window.removeEventListener('resize', apply); document.documentElement.classList.remove('tk-esc80'); };
  }, []);

  return (
    <>
      <style>{`
        *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
        html, body {
          overflow: hidden;
          font-family: ${SF};
          -webkit-font-smoothing: antialiased;
          -moz-osx-font-smoothing: grayscale;
        }

        /* ── Escala compacta: zoom 80 % y alto de pantalla compensado (--vh) ── */
        :root { --vh: 100vh; }
        html.tk-esc80 { zoom: .8; --vh: 125vh; }

        /* ── Root ── */
        .lyt-root { display: flex; flex-direction: column; height: var(--vh, 100vh); overflow: hidden; background: #f5f5f3; }

        /* ── Top bar (sobria: blanco, grises, esquinas 6–8 px, letra regular) ── */
        .lyt-topbar {
          height: 52px;
          background: #fff;
          border-bottom: 1px solid #EFEFEF;
          display: flex; align-items: center;
          padding: 0 20px;
          flex-shrink: 0; z-index: 200;
          gap: 14px; position: relative;
          animation: lyt-slideDown .3s cubic-bezier(.4,0,.2,1) both;
        }

        /* Brand */
        .lyt-brand {
          display: flex; align-items: center; gap: 9px; flex-shrink: 0;
          padding-right: 14px; border-right: 1px solid #EFEFEF;
          margin-right: 2px;
        }
        .lyt-brand-logo {
          width: 28px; height: 28px; border-radius: 6px;
          background: #fff; border: 1px solid #EFEFEF;
          display: flex; align-items: center; justify-content: center;
          overflow: hidden; flex-shrink: 0;
          transition: transform .2s;
        }
        .lyt-brand-logo:hover { transform: translateY(-1px); }
        .lyt-brand-logo img { width: 18px; height: 18px; object-fit: contain; }
        .lyt-brand-name {
          font-size: 14px; font-weight: 500; color: #111;
          letter-spacing: -.1px; white-space: nowrap;
        }
        .lyt-brand-sep {
          width: 1px; height: 14px; background: #E5E7EB; margin: 0 1px;
        }
        .lyt-brand-sub {
          font-size: 12.5px; font-weight: 400; color: #9CA3AF;
          white-space: nowrap;
        }

        /* Menú */
        .lyt-nav-pill {
          display: flex; align-items: center; align-self: stretch;
          gap: 2px; min-width: 0;
          animation: lyt-fadeIn .35s ease .05s both;
        }

        .lyt-nav-item {
          display: flex; align-items: center; gap: 7px;
          padding: 6px 11px;
          border-radius: 6px;
          border: none; background: transparent;
          font-family: inherit; font-size: 13px; font-weight: 400;
          color: #6B7280; cursor: pointer;
          transition: background .15s, color .15s, transform .15s;
          white-space: nowrap; position: relative;
        }
        .lyt-nav-item:hover { color: #111; background: #F5F5F5; }
        .lyt-nav-item:active { transform: scale(.97); }
        .lyt-nav-item.is-active { color: #111; background: #F3F3F3; }
        .lyt-nav-pill .lyt-nav-item.is-active::after {
          content: ''; position: absolute; bottom: -10px; left: 11px; right: 11px;
          height: 2px; border-radius: 1px; background: #111;
          animation: lyt-lineGrow .25s ease both;
        }
        .lyt-nav-ico { display: flex; align-items: center; flex-shrink: 0; color: #9CA3AF; transition: color .15s; }
        .lyt-nav-item:hover .lyt-nav-ico, .lyt-nav-item.is-active .lyt-nav-ico { color: #111; }

        /* Separador antes de Configuraciones */
        .lyt-nav-sep {
          width: 1px; height: 16px; background: #EFEFEF;
          flex-shrink: 0; margin: 0 4px;
        }

        /* More button (mobile overflow) */
        .lyt-nav-more {
          display: none; align-items: center; justify-content: center;
          width: 32px; height: 32px; border-radius: 6px;
          background: transparent; border: none; cursor: pointer;
          color: #6B7280; font-size: 18px;
          transition: background .15s;
        }
        .lyt-nav-more:hover { background: #F5F5F5; }

        /* Derecha */
        .lyt-right {
          display: flex; align-items: center; gap: 6px;
          margin-left: auto; flex-shrink: 0;
        }
        .lyt-tb-btn {
          width: 32px; height: 32px; border-radius: 6px;
          border: 1px solid #EFEFEF; background: #fff; color: #6B7280;
          display: flex; align-items: center; justify-content: center;
          cursor: pointer; flex-shrink: 0;
          transition: background .15s, color .15s, transform .15s, border-color .15s;
          animation: lyt-fadeIn .3s ease .15s both;
        }
        .lyt-tb-btn:hover { background: #F7F7F7; color: #111; border-color: #E5E7EB; transform: translateY(-1px); }
        .lyt-tb-btn:active { transform: scale(.95); }
        .lyt-bell-n {
          position: absolute; top: -6px; right: -7px; min-width: 17px; height: 17px; padding: 0 4px;
          border-radius: 4px; background: #111; color: #fff; border: 2px solid #fff;
          font-size: 10px; font-weight: 400; line-height: 13px; text-align: center; box-sizing: border-box;
          animation: lyt-bump .3s cubic-bezier(.34,1.56,.64,1) both;
        }
        @keyframes lyt-bump { from { transform: scale(.6); opacity: 0; } to { transform: scale(1); opacity: 1; } }
        .lyt-tb-btn.is-on { background: #F3F3F3; color: #111; border-color: #E5E7EB; }

        /* Mobile hamburger */
        .lyt-hamburger {
          display: none; width: 32px; height: 32px; border-radius: 6px;
          background: #fff; border: 1px solid #EFEFEF;
          align-items: center; justify-content: center;
          cursor: pointer; color: #6B7280; flex-shrink: 0;
          transition: background .15s, color .15s;
        }
        .lyt-hamburger:hover { background: #F7F7F7; color: #111; }

        /* Mobile menu */
        .lyt-mobile-menu {
          display: none; position: fixed; top: 52px; left: 0; right: 0;
          background: #fff; z-index: 199;
          padding: 8px 12px; border-bottom: 1px solid #EFEFEF;
          box-shadow: 0 8px 24px rgba(0,0,0,.06);
          animation: lyt-slideDown .2s ease both;
        }
        .lyt-mobile-menu .lyt-nav-item {
          width: 100%; justify-content: flex-start; padding: 10px 12px;
          font-size: 14px;
        }

        .lyt-overlay {
          position: fixed; inset: 0; top: 52px;
          background: rgba(17,17,17,.25); z-index: 198;
          animation: lyt-fadeIn .2s ease;
        }

        @media (max-width: 1100px) {
          .lyt-nav-item { padding: 6px 8px; gap: 6px; }
          .lyt-nav-pill .lyt-nav-item.is-active::after { left: 8px; right: 8px; }
        }
        @media (max-width: 900px) {
          .lyt-nav-pill { display: none; }
          .lyt-hamburger { display: flex; }
          .lyt-mobile-menu.is-open { display: flex; flex-direction: column; }
          .lyt-brand-sub, .lyt-brand-sep { display: none; }
        }

        /* ── Content ── */
        .lyt-content {
          flex: 1; display: flex; flex-direction: column;
          overflow: hidden; min-width: 0;
          position: relative;
        }

        /* Page transition wrapper */
        .lyt-page {
          flex: 1; display: flex; flex-direction: column;
          overflow: hidden; min-width: 0;
          animation: lyt-pageIn .45s cubic-bezier(.4,0,.2,1) both;
        }

        /* Progress bar */
        .lyt-progress {
          position: absolute; top: 0; left: 0; right: 0;
          height: 2.5px; z-index: 50; overflow: hidden;
          pointer-events: none;
        }
        .lyt-progress-bar {
          height: 100%;
          background: linear-gradient(90deg, transparent, #88da21 30%, #6ee7b7 70%, #88da21);
          border-radius: 0 2px 2px 0;
          animation: lyt-progressRun .5s cubic-bezier(.4,0,.2,1) both;
          box-shadow: 0 0 8px rgba(136,218,33,.4), 0 0 2px rgba(136,218,33,.6);
        }

        /* Shimmer overlay */
        .lyt-shimmer {
          position: absolute; inset: 0; z-index: 40;
          pointer-events: none;
          background: linear-gradient(
            110deg,
            transparent 30%,
            rgba(136,218,33,.03) 45%,
            rgba(136,218,33,.06) 50%,
            rgba(136,218,33,.03) 55%,
            transparent 70%
          );
          background-size: 250% 100%;
          animation: lyt-shimmerSlide .6s ease both;
        }

        /* Animations */
        @keyframes lyt-slideDown { from { opacity: 0; transform: translateY(-8px); } to { opacity: 1; transform: translateY(0); } }
        @keyframes lyt-pillGrow { from { opacity: 0; transform: scaleX(.85); } to { opacity: 1; transform: scaleX(1); } }
        @keyframes lyt-lineGrow { from { transform: scaleX(0); } to { transform: scaleX(1); } }
        @keyframes lyt-fadeIn { from { opacity: 0; } to { opacity: 1; } }
        @keyframes lyt-avatarPop { from { opacity: 0; transform: scale(.6); } to { opacity: 1; transform: scale(1); } }
        @keyframes lyt-fade { from { opacity: 0; } to { opacity: 1; } }
        @keyframes lyt-pageIn {
          0%   { opacity: 0; transform: translateY(10px) scale(.995); filter: blur(3px); }
          60%  { opacity: 1; filter: blur(0); }
          100% { opacity: 1; transform: translateY(0) scale(1); filter: blur(0); }
        }
        @keyframes lyt-progressRun {
          0%   { width: 0; }
          40%  { width: 65%; }
          80%  { width: 90%; }
          100% { width: 100%; opacity: 0; }
        }
        @keyframes lyt-shimmerSlide {
          0%   { background-position: 150% 0; opacity: 1; }
          100% { background-position: -50% 0; opacity: 0; }
        }
        @keyframes spin { to { transform: rotate(360deg); } }
        .spinner {
          width: 16px; height: 16px;
          border: 2px solid #e5e7eb; border-top-color: #6ee7b7;
          border-radius: 50%; animation: spin .7s linear infinite;
          display: inline-block;
        }
      `}</style>

      {mobileMenu && <div className="lyt-overlay" onClick={() => setMobileMenu(false)}/>}

      <div className="lyt-root">

        {/* ══════════ TOP BAR ══════════ */}
        <header className="lyt-topbar">

          {/* Hamburger (mobile) */}
          <button className="lyt-hamburger" onClick={() => setMobileMenu(v => !v)}>
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><line x1="3" y1="6" x2="21" y2="6"/><line x1="3" y1="12" x2="21" y2="12"/><line x1="3" y1="18" x2="21" y2="18"/></svg>
          </button>

          {/* Brand */}
          <div className="lyt-brand">
            <div className="lyt-brand-logo">
              <img src={FAVICON_TALKU} alt="Talku"/>
            </div>
            <span className="lyt-brand-name">Talku</span>
            <div className="lyt-brand-sep"/>
            <span className="lyt-brand-sub">CRM</span>
          </div>

          {/* Nav pill */}
          <nav className="lyt-nav-pill">
            {NAV_ITEMS.map(({ id, label, Icon }, i) => (
              <React.Fragment key={id}>
                {i === NAV_ITEMS.length - 1 && <div className="lyt-nav-sep"/>}
                <button
                  className={`lyt-nav-item${activeNav === id ? ' is-active' : ''}`}
                  onClick={() => handleNav(id)}
                >
                  <span className="lyt-nav-ico"><Icon a={activeNav === id}/></span>
                  {label}
                </button>
              </React.Fragment>
            ))}
          </nav>

          {/* Right */}
          <div className="lyt-right">
            <button ref={bellRef} className={`lyt-tb-btn${showNotifs ? ' is-on' : ''}`} onClick={() => setShowNotifs(v => !v)} title={unreadN ? `${unreadN} chats sin leer` : 'Notificaciones'} style={{ position:'relative' }}>
              <IcoBell/>
              {unreadN > 0 && <span className="lyt-bell-n" key={unreadN}>{unreadN > 99 ? '99+' : unreadN}</span>}
            </button>
            <button className="lyt-tb-btn" title="Ayuda">
              <IcoHelp/>
            </button>
            <ProfileMenu user={user} onNav={onNav} onLogout={onLogout}/>
          </div>
        </header>

        {/* Mobile nav dropdown */}
        <div className={`lyt-mobile-menu${mobileMenu ? ' is-open' : ''}`}>
          {NAV_ITEMS.map(({ id, label, Icon }) => (
            <button
              key={id}
              className={`lyt-nav-item${activeNav === id ? ' is-active' : ''}`}
              onClick={() => handleNav(id)}
            >
              <span className="lyt-nav-ico"><Icon a={activeNav === id}/></span>
              {label}
            </button>
          ))}
        </div>

        {/* ══════════ CONTENT ══════════ */}
        <main className="lyt-content">
          <div className="lyt-progress" key={`prog-${activeNav}`}>
            <div className="lyt-progress-bar"/>
          </div>
          <div className="lyt-shimmer" key={`shim-${activeNav}`}/>
          <div className="lyt-page" key={activeNav}>
            {children}
          </div>
        </main>

        {showNotifs && <NotificationPanel items={unread} onOpen={openConv} onClose={() => setShowNotifs(false)} ignoreRef={bellRef}/>}
        <AlertToasts toasts={toasts} leaving={leaving} dismiss={dismiss} onOpen={openConv}/>
      </div>
    </>
  );
}
